import { createFileRoute } from '@tanstack/react-router';
import { LoginCallback } from '@okta/okta-react';

export const Route = createFileRoute('/login_/callback')({
  component: LoginCallback,
});
